import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import useScript from "../../../hooks/use-script";
import * as s from "./EmbedSocial.module.scss";

type EmbedSocialProps = {
	dataRef?: string;
};

const EmbedSocial: FC<EmbedSocialProps> = ({
	dataRef = "e2eeb8e3e44235279119e34e2caa05762e2295f0",
}) => {
	useScript({
		script: {
			id: "embedsocial_script",
			type: "text/javascript",
			src: `https://embedsocial.com/embedscript/stg.js`,
			async: true,
		},
		removeOnUnmount: true,
		shouldRender: !!dataRef,
	});

	if (!dataRef) return null;

	return (
		<div
			className={cn(s.wrapper, "embedsocial-story-gallery")}
			data-ref={dataRef}
		></div>
	);
};

export default EmbedSocial;
